import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

const staticRedirects = ['alpha-capital', 'ttp', 'cti', 'e8', 'fxify'];

export function AffiliateRedirect() {
  const { firmId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function redirectToAffiliate() {
      if (!firmId) {
        navigate('/reviews', { replace: true });
        return;
      }

      // ⛔ If firmId matches static redirect, skip Supabase call
      if (staticRedirects.includes(firmId)) {
        console.info(`[Redirect Skipped] ${firmId} is handled by Netlify _redirects.`);
        return;
      }

      try {
        // Optional: track click
        try {
          // @ts-ignore
          if (window.gtag) {
            // @ts-ignore
            window.gtag('event', 'affiliate_click', {
              firm: firmId
            });
          }
        } catch (e) {
          console.error('Error tracking affiliate click:', e);
        }

        // Fetch from Supabase (only for dynamic/fallback)
        const { data, error } = await supabase
          .from('affiliate_links')
          .select('redirect_url')
          .eq('prop_name', firmId)
          .single();

        if (error || !data) {
          console.error('Error fetching affiliate link:', error);
          navigate('/reviews', { replace: true });
          return;
        }

        window.location.href = data.redirect_url;
      } catch (error) {
        console.error('Error during redirect:', error);
        navigate('/reviews', { replace: true });
      } finally {
        setLoading(false);
      }
    }

    redirectToAffiliate();
  }, [firmId, navigate]);

  if (!loading || staticRedirects.includes(firmId || '')) {
    return null;
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-2xl font-bold mb-4">Redirecting...</h1>
        <p className="text-gray-600">Please wait while we redirect you to {firmId?.toUpperCase()}.</p>
      </div>
    </div>
  );
}
